function GlobalNavigationController (selector, config) {
    var vueCtrl = new Vue({
        el: selector,
        data: {
            //currentEvent: config.currentEvent
        },
        mounted: function () {
        },
        created: function () {
            // make nav components

            // close dropdown menu if you click outside of the nav
            $('body').click(function(e){
                if($('.navbar__dropdown-menu').is(e.target) || $('.navbar__list-item-link').is(e.target) || $('.navbar__list-item-text').is(e.target)) { 
                    return;
                } else {
                    $('.navbar__dropdown-menu').collapse('hide').removeClass('show');   
                }
            });
            
        },
        methods: {
            toggleOpenMenus: function(clicked){
                $('.navbar__dropdown-menu').collapse('hide').removeClass('show');
            }
        },
    })
    return vueCtrl
  }
  
  export default GlobalNavigationController